import { useTranslation } from 'react-i18next';
import { useAllCampaignCategoryOptions } from '@anytag/shared-hooks';
import { SelectorField, SingleSelectorFieldProps } from '@anytag/shared-molecules';
import { MarketplaceFormKeys } from '../types';

type CampaignCategoryFieldProps<T extends string = keyof typeof MarketplaceFormKeys> = Partial<
  Omit<SingleSelectorFieldProps<T>, 'options' | 'multiple'>
>;

export const CampaignCategoryField = <T extends string = keyof typeof MarketplaceFormKeys>({
  name,
  ...restProps
}: CampaignCategoryFieldProps<T>) => {
  const { t } = useTranslation();
  const { allCampaignCategoryOptions } = useAllCampaignCategoryOptions();

  return (
    <SelectorField<T>
      title={t('Selector.Campaign Category')}
      help={t('Tooltip.Campaign Category')}
      options={allCampaignCategoryOptions}
      name={name || (MarketplaceFormKeys.campaignCategoryId as T)}
      {...restProps}
    />
  );
};
